import { GameObjects, Scene, Physics, Tilemaps, Types } from 'phaser';
import { Player } from './player';

export class SecondPlayer extends GameObjects.Sprite {
  static ID = 0;
  id = 0;
  mainPlayer: Player;
  rotRightKey: string;
  rotLeftKey: string;
  rotSpeed = 0.02;
  cursors;
  body: Physics.Arcade.Body;
  walls: Tilemaps.StaticTilemapLayer;
  onTiles: Tilemaps.Tile[];
  futureTiles: Tilemaps.Tile[];
  posRotation;
  constructor(
    scene: Scene,
    mainPlayer: Player,
    rotation: number,
    rotLeftKey: string,
    rotRightKey: string,
    walls: Tilemaps.StaticTilemapLayer
  ) {
    super(scene, 0, 0, 'secondPlayer' + SecondPlayer.ID);
    this.walls = walls;
    this.id = SecondPlayer.ID++;
    this.posRotation = rotation;
    this.mainPlayer = mainPlayer;
    this.rotLeftKey = rotLeftKey;
    this.rotRightKey = rotRightKey;
    this.createControls();
    this.scene.add.existing(this);
    this.scene.physics.add.existing(this);
    this.setOrigin(0, 0);
    this.setSize(16, 16);
    this.body.setSize(this.width, this.height, true);
    this.scene.physics.add.collider(this, walls);
    const walkConfig: Types.Animations.Animation = {
      key: 'nega_walk',
      frames: this.scene.anims.generateFrameNumbers('nega_walk', null),
      frameRate: 4,
      repeat: -1,
    };
    this.scene.anims.create({ ...walkConfig });
    this.anims.load('nega_walk');
  }
  
  preUpdate = (time, delta) => {
    super.preUpdate(time, delta);
    this.anims.play('nega_walk', true);
    // todo change position from player1
    // apply any rotation with pivot point from main player x,y
    if (this.scene.physics.collide(this, this.walls)) {
      return;
    }
    let alphaCpy = this.posRotation;
    if (this.cursors.rotLeft.isDown) {
      alphaCpy -= this.rotSpeed;
    }
    if (this.cursors.rotRight.isDown) {
      alphaCpy += this.rotSpeed;
    }
    const newPos = this.getCirclePos(
      this.mainPlayer.x,
      this.mainPlayer.y,
      this.mainPlayer.radius,
      alphaCpy
    );
    this.onTiles = this.walls.getTilesWithinWorldXY(
      this.x,
      this.y,
      this.width,
      this.height
    );
    this.futureTiles = this.walls.getTilesWithinWorldXY(
      newPos.x,
      newPos.y,
      this.width,
      this.height
    );
    if (!this.futureTiles.find((tile) => tile.index != 1)) {
      this.posRotation = alphaCpy;
      this.x = newPos.x;
      this.y = newPos.y;
    }
  };

  getCirclePos = (x, y, radius, rad) => {
    const newX = x + radius * Math.cos(rad);
    const newY = y + radius * Math.sin(rad);
    return { x: newX, y: newY };
  };
  private createControls = () => {
    this.cursors = this.scene.input.keyboard.addKeys({
      rotLeft: Phaser.Input.Keyboard.KeyCodes[this.rotLeftKey],
      rotRight: Phaser.Input.Keyboard.KeyCodes[this.rotRightKey],
    });
  };
}
